$tablet-breakpoint: 840px;
$mobile-breakpoint: 480px;

.order-flow-wrapper {
  max-width: 1440px;
  padding: 0 104px;
  margin: 0 auto;

  @media only screen and (max-width: $tablet-breakpoint) {
    padding: 0 48px;
  }

  @media only screen and (max-width: $mobile-breakpoint) {
    padding: 0 16px;
  }
}
